import { Client } from '@crochik/pi-react/api/Client';

interface SignInWithSecret {
    client_id?: string;
    client_secret?: string;
    scope?: string;
}

export interface Token {
    access_token: string;
    expires_in: number;
    token_type: string;
}

export class IdentityClient extends Client {
    async singInWithSecret(opts: SignInWithSecret): Promise<Token> {
        var data = {
            ...opts,
            grant_type: 'client_credentials'
        };

        return await this.postJson<Token>('/connect/token', data, 'application/x-www-form-urlencoded');
    }
}


// WEBPACK FOOTER //
// ./src/app/services/api/IdentityClient.tsx